// extracted by mini-css-extract-plugin
export default {"pagination":"SuperPagination_pagination__o8VTF","text1":"SuperPagination_text1__YyOCK","text2":"SuperPagination_text2__oO3+s"};